import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, RefreshCcw, Home, Mail } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 to-orange-50">
      <Header />

      <div className="max-w-3xl mx-auto py-16 px-4">
        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden">
          {/* Header Cancel */}
          <div className="bg-gradient-to-r from-red-600 to-orange-600 px-8 py-12 text-center">
            <XCircle className="w-24 h-24 mx-auto text-white mb-6" />
            <h1 className="text-4xl font-bold text-white mb-3">Plată Anulată</h1>
            <p className="text-red-100 text-lg">Tranzacția a fost anulată sau a eșuat</p>
          </div>

          {/* Content */}
          <div className="p-8">
            <div className="bg-yellow-50 border-2 border-yellow-200 rounded-xl p-6 mb-8">
              <h3 className="font-semibold text-yellow-900 mb-2 text-lg">Ce s-a întâmplat?</h3>
              <p className="text-yellow-800">
                Plata nu a fost finalizată. Acest lucru poate fi cauzat de:
              </p>
              <ul className="list-disc list-inside text-yellow-800 mt-3 ml-4 space-y-1">
                <li>Ați anulat tranzacția manual</li>
                <li>Au fost fonduri insuficiente pe card</li>
                <li>Datele cardului au fost introduse incorect</li>
                <li>Banca a respins tranzacția</li>
              </ul>
            </div>

            <div className="space-y-6">
              <div className="flex items-start gap-4 p-4 bg-gray-50 rounded-lg">
                <RefreshCcw className="w-6 h-6 text-emerald-600 flex-shrink-0 mt-1" />
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">Doriți să reîncercați?</h4>
                  <p className="text-gray-600 text-sm">
                    Puteți reveni la pagina principală și să plasați o nouă comandă.
                    Datele dumneavoastră nu au fost salvate.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4 p-4 bg-gray-50 rounded-lg">
                <Mail className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" />
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">Aveți nevoie de ajutor?</h4>
                  <p className="text-gray-600 text-sm">
                    Dacă întâmpinați probleme persistente cu plata, vă rugăm să ne contactați
                    și vom fi bucuroși să vă ajutăm.
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-10 pt-8 border-t border-gray-200 flex gap-4 justify-center flex-wrap">
              <button
                onClick={() => navigate('/')}
                className="flex items-center gap-2 px-8 py-3 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 font-semibold transition-all">
                <RefreshCcw className="w-5 h-5" />
                Încearcă Din Nou
              </button>

              <button
                onClick={() => navigate('/')}
                className="flex items-center gap-2 px-8 py-3 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 font-semibold transition-all">
                <Home className="w-5 h-5" />
                Pagina Principală
              </button>
            </div>

            <div className="mt-6 text-center">
              <p className="text-sm text-gray-500 mb-2">
                Pentru asistență contactați-ne:
              </p>
              <p className="text-sm">
                <a href="mailto:contact@cf-extras.ro" className="text-emerald-600 hover:underline font-medium">
                  contact@cf-extras.ro
                </a>
                {' | '}
                <a href="tel:+40756888282" className="text-emerald-600 hover:underline font-medium">
                  +40 756 888 282
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PaymentCancel;
